'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Sidebar = require('./components/Sidebar.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Sidebar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-drawer/lib/components/sidebar/index.js
// module id = 1066
// module chunks = 1